// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import type {
  DynamicQuestionContent,
  QuestionTypeDetails,
} from "@modules/service/reducer/dynamic-questions/types";
import * as serviceSelectors from "@modules/service/selectors";
import { Button, SchemaForm } from "@components";
import { split } from "@transformers/schema";
import { questionTypeUiSchema } from "./ui-schema.js";
import type { StepProps } from "@components";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step1QuestionType extends React.Component<Props> {
  questionTypeSchema = split(this.props.schema, [
    "questionType",
    "questionText",
    "isMandatory",
    "isActive",
    "advisorType",
    "startNotification",
    "updateNotification",
    "closeNotification",
  ]);

  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  handleQuestionTypeNext = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };
      this.props.onUpdateDraft(updatedDraft);
      if (this.props.handleSubmit) {
        this.props.handleSubmit(updatedDraft, true);
      }
    }
  };

  get data(): QuestionTypeDetails {
    return {
      questionType: (this.props.draft || {}).questionType,
      questionText: (this.props.draft || {}).questionText,
      isMandatory: (this.props.draft || {}).isMandatory,
      isActive: (this.props.draft || {}).isActive,
      advisorType: "ALL",
      startNotification: false,
      updateNotification: (this.props.draft || {}).updateNotification,
      closeNotification: (this.props.draft || {}).closeNotification,
    };
  }

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            {this.data && (
              <SchemaForm
                ref={this.formRef}
                className="w-100"
                formData={this.data}
                schema={this.questionTypeSchema || {}}
                uiSchema={questionTypeUiSchema(this.props.t)}
                onSubmit={this.handleSubmit}
                externalSubmit
              />
            )}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button materialIcon="fast_forward" onClick={this.handleQuestionTypeNext}>
            {this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1QuestionType);
